import styled from 'styled-components';

interface CardDescriptionProps {
  description: string;
}

const CardDescription = ({ description }: CardDescriptionProps) => {
  return <Container>{description}</Container>;
};

const Container = styled.h2`
  font-size: 12px;
  height: 17px;
  font-family: materialRegular;
  color: #5b6573;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;

  @media (max-width: ${props => props.theme.breakPoints.mobile.max}) {
    font-size: 11px;
  }
`;

export default CardDescription;
